import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetFareConditionsRequest,
  failGetFareConditions,
  setGetFareConditions,
  setGetFareConditionsFromApi,
  updateGetFareConditions,
  updateGetFareConditionsFromApi,
} from './get-fare-conditions.actions';

/**
 * Service to handle async GetFareConditions actions
 */
@Injectable()
export class GetFareConditionsEffect {
  /**
   * Set the state with the reply content, dispatch failGetFareConditions if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetFareConditionsFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetFareConditions({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetFareConditions({ error, requestId: action.requestId })),
        cancelGetFareConditionsRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetFareConditions if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetFareConditionsFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetFareConditions({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetFareConditions({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
